import "./libs/jquery-jvectormap-world-mill"

/**
 * World Map Component
 *
 * @constructor
 */

export default function()
{

    const $target = $('#world-map')

    if($target.length === 0) return

    const data = {
        "RO": {
            ips: 123456,
            checks: [
                'Data center IPs',
                'Residential IPs'
            ]
        },
        "US": {
            ips: 999999,
            checks: [
                'Data center IPs',
                'Residential IPs'
            ]
        },
        //...
    }

    function tooltip(e, el, code) {
        el.html(
            `<a class="tooltip service" role="tooltip" x-placement="bottom" style="">
                <div class="tooltip-arrow"></div>
                <div class="tooltip-inner">
                    <div class="country">${el.html()}</div>
                    <div class="ips">${window.countries_ip[code]}</div>
                    <div class="meta">number of IPS</div>
                    <div class="item"><span>Data center IPs</span></div>
                    <div class="item"><span>Residential IPs</span></div>
                </div>
            </a>`
        )
    }

    $target.vectorMap({
        map: 'world_mill',
        backgroundColor: 'ffffff',
        zoomOnScroll: false,
        series: {
            regions: [{
                values: window.countries_ip,
                scale: ['#C8EEFF', '#0071A4'],
                normalizeFunction: 'polynomial'
            }]
        },
        onRegionTipShow: tooltip
    })
}
